import Vue from 'vue'
import Router from 'vue-router'
import config from '../../config'
/* Layout */
import Layout from '@/layout'
import Map from '@/views/map';

Vue.use(Router)

/**
 * Note: 路由配置项
 *
 * hidden: true                   // 【重要】当设置 true 的时候该路由不会再侧边栏出现 如 401，login 等页面，或者如一些编辑页面 /edit/1
 * alwaysShow: true               // 当你一个路由下面的 children 声明的路由大于1个时，自动会变成嵌套的模式--如组件页面
 *                                // 只有一个时，会将那个子路由当做根路由显示在侧边栏--如引导页面
 *                                // 若你想不管路由下面的 children 声明的个数都显示你的根路由
 *                                // 你可以设置 alwaysShow: true，这样它就会忽略之前定义的规则，一直显示根路由
 * path: '/login',                // 【重要】访问的 URL 路径
 * component: Layout,             // 【重要】对应的组件；也可以是 (resolve) => require(['@/views/login'], resolve),
 * redirect: noRedirect           // 当设置 noRedirect 的时候该路由在面包屑导航中不可被点击
 * name:'router-name'             // 【重要】设定路由的名字，一定要填写不然使用 <keep-alive> 时会出现各种问题
 * meta : {
 noCache: true                // 【重要】如果设置为 true，则不会被 <keep-alive> 缓存(默认 false)
 title: 'title'               // 【重要】设置该路由在侧边栏和面包屑中展示的名字
 icon: 'svg-name'             // 【重要】设置该路由的图标，对应路径 src/assets/icons/svg
 breadcrumb: false            // 如果设置为 false，则不会在 breadcrumb 面包屑中显示
 activeMenu: '/system/user'   // 当路由设置了该属性，则会高亮相对应的侧边栏。
 }
 */

// 公共路由
export const constantRoutes = [
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: (resolve) => require(['@/views/redirect'], resolve)
      }
    ]
  },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: 'data-overview',
  //   children: [{
  //     path: 'data-overview',
  //     component: (resolve) => require(['@/views/DataOverview'], resolve),
  //     name: '首页',
  //     meta: {title: '首页', icon: 'dashboard', affix: true}
  //   }]
  // },
  {
    path: '/login',
    component: (resolve) => require(['@/views/login'], resolve),
    hidden: true
  },

  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/data-overview',
    children: [{
      path: '/data-overview',
      component: (resolve) => require(['@/views/DataOverview'], resolve),
      name: '数据总览',
      meta: {title: '数据总览', icon: 'dashboard', affix: true}
    }]
  },
  {
  path: '/user',
  component: Layout,
  redirect: '/user/list',
  name: 'User',
  meta: { title: '用户管理', icon: 'user' },
  hidden: true, // ✅ 隐藏父级菜单，只显示子级
  children: [
    {
      path: 'list',
      name: 'UserList',
      component: (resolve) => require(['@/views/user/user'], resolve),
      meta: { title: '用户列表', icon: 'user' }
    },
    {
      path: ':id',
      name: 'UserDetail',
      component: (resolve) => require(['@/views/user/detail'], resolve),
      meta: {
        title: '用户详情',
        activeMenu: '/user/list',
        noCache: true
      },
      hidden: true
    }
  ]
},

  {
    path: '/map',
    name: '数据大屏',
    component: Map,
    hidden: true,
    meta: {
        requireAuth: false
    }
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/reality-detail',
    children: [{
      path: '/reality-detail',
      component: (resolve) => require(['@/views/card/RealityDetail'], resolve),
      name: '充电卡详情',
      meta: {title: '充电卡详情', icon: 'dashboard'}
    }]
  },

  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/area-detail',
    children: [{
      path: '/area-detail',
      component: (resolve) => require(['@/views/area/AreaDetails'], resolve),
      name: '片区详情',
      meta: {title: '片区详情', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/area-add',
    children: [{
      path: '/area-add',
      component: (resolve) => require(['@/views/area/ZoneAdd'], resolve),
      name: '新增片区',
      meta: {title: '新增片区', activeMenu: '/area/list', noCache: true}
    }]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/area-edit',
    children: [{
      path: '/area-edit',
      component: (resolve) => require(['@/views/area/ZoneAdd'], resolve),
      name: '编辑片区',
      meta: {title: '编辑片区', activeMenu: '/area/list', noCache: true}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/station-detail',
    hidden: true,
    children: [{
      path: '/station-detail',
      component: (resolve) => require(['@/views/operator/StationDetails'], resolve),
      name: '充电站详情',
      meta: {title: '充电站详情', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/station-add',
    children: [{
      path: '/station-add',
      component: (resolve) => require(['@/views/chargingstation/StationAdd'], resolve),
      name: '新增充电站',
      meta: {title: '新增充电站', activeMenu: '/area/list', noCache: true}
    }]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/station-edit',
    children: [{
      path: '/station-edit',
      component: (resolve) => require(['@/views/chargingstation/StationAdd'], resolve),
      name: '编辑充电站',
      meta: {title: '编辑充电站', activeMenu: '/area/list', noCache: true}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/order-detail',
    hidden: true,
    children: [{
      path: '/order-detail',
      component: (resolve) => require(['@/views/order/OrderDetails'], resolve),
      name: '充电订单详情',
      meta: {title: '充电订单详情', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/order-abnormal-detail',
    hidden: true,
    children: [{
      path: '/order-abnormal-detail',
      component: (resolve) => require(['@/views/order/OrderChargingDetails'], resolve),
      name: '异常充电中订单详情',
      meta: {title: '异常充电中订单详情', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/settlement-detail',
    hidden: true,
    children: [{
      path: '/settlement-detail',
      component: (resolve) => require(['@/views/settlement/AccountDetail'], resolve),
      name: '分账账户详情',
      meta: {title: '分账账户详情', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    redirect: '/splitaccount-detail',
    hidden: true,
    children: [{
      path: '/splitaccount-detail',
      component: (resolve) => require(['@/views/revenuesharing/SplitAccountDetail'], resolve),
      name: '分账账户',
      meta: {title: '分账账户', icon: 'dashboard'}
    }]
  },
  {
    path: '',
    component: Layout,
    hidden: true,
    redirect: '/job-log',
    children: [{
      path: '/job-log',
      component: (resolve) => require(['@/views/job/JobLogList'], resolve),
      name: '定时任务日志',
      meta: {title: '定时任务日志', icon: 'dashboard'}
    }]
  },
]

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}

const createRouter = () => new Router({
  base:  process.env.NODE_ENV === 'production' ? config.build.assetsPublicPath : config.dev.assetsPublicPath,
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({y: 0}),
  routes: constantRoutes
})

const router = createRouter()

// 重置路由函数
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 重置路由
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js